<template>
  <div class="user-login">
    <a class="img_logo">
      <img :src="require('@/assets/bdj-logo.png')" />
    </a>
    <div
      class="user-login-bg"
      :style="{'background-image':`url(${backgroundImage})`}"
    ></div>
    <div class="content-wrapper">
      <h2 class="slogan">
        欢迎使用
        <br />
        {{platformName}}
      </h2>
      <div class="form-container">
        <h4 class="form-title">登录</h4>
        <el-form
          ref="form"
          :model="user"
          label-width="0"
        >
          <div class="form-items">
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  prop="username"
                  label="邮箱号或用户名:"
                  required
                  hidden-label
                >
                  <div class="form-line">
                    <i class="el-icon-s-custom input-icon"></i>
                    <el-input
                      placeholder="邮箱/用户名"
                      v-model="user.username"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  prop="password"
                  label="密码:"
                  required
                  hidden-label
                >
                  <div class="form-line">
                    <i class="el-icon-view input-icon"></i>
                    <el-input
                      type="password"
                      placeholder="密码"
                      v-model="user.password"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-col>
                <el-form-item>
                  <!-- <el-checkbox class="checkbox">记住账号</el-checkbox> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-button
                type="primary"
                class="submit-btn"
                size="small"
                @click="submitBtn"
              >登 录</el-button>
            </el-row>
          </div>
          <el-row class="tips">
            <a
              href="#/register"
              class="link"
            >考生注册</a>
            <span class="line">|</span>
            <a
              href="#/findPwd"
              class="link"
            >忘记密码</a>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
const backgroundImage = '/static/images/login-bg.jpg'
import { platformName } from '@/config/GlobalText'
import { storageUtil } from '@/utils'
import { userRes } from '@/api'
export default {
  name: 'UserLogin',
  data() {
    return {
      platformName,
      backgroundImage: backgroundImage,
      user: {
        username: '',
        password: ''
      }
    }
  },
  created() {},
  methods: {
    async submitBtn() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const { user } = this
          userRes.login(user).then(res => {
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            this.$emit('getPermission')
            this.$router.push('/')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" >
.user-login {
  :global {
    .el-input__inner {
      border: none;
    }
  }
  .el-form-item__error {
    padding-left: 10px;
  }
  .user-login-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: #0a0a0a63;
    }
  }
  .el-checkbox__label {
    color: #999;
    font-size: 13px;
  }
  .content-wrapper {
    position: absolute;
    top: -100px;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 1080px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .slogan {
      text-align: center;
      color: #fff;
      font-size: 36px;
      letter-spacing: 2px;
      line-height: 48px;
      float: left\0;
      position: absolute\0;
      left: 0\0;
      top: 35%\0;
    }
  }
  .form-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 30px 40px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 1px 1px 2px #eee;
    float: right\0;
    position: absolute\0;
    right: 0\0;
    top: 35%\0;
  }
  .el-form-item {
    margin-bottom: 23px;
  }
  .form-Item {
    position: relative;
    flex-direction: column;
  }
  .form-line {
    position: relative;
    display: flex;
    align-items: center;
    &:after {
      content: '';
      position: absolute;
      bottom: 3px;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-color: #dcdcdc;
      border-radius: 0;
    }
  }
  .el-input {
    width: 240px;
    input {
      border: none;
      margin: 0;
      padding-left: 10px;
      font-size: 13px;
    }
  }
  .form-title {
    margin: 0 0 20px;
    text-align: center;
    color: #3080fe;
    letter-spacing: 12px;
  }
  .input-icon {
    color: #999;
  }
  .checkbox {
    margin-left: 5px;
  }
  .submit-btn {
    margin-bottom: 25px;
    width: 100%;
    background: #3080fe;
    border-radius: 28px;
  }
  .tips {
    text-align: center;
  }
  .link {
    color: #999;
    text-decoration: none;
    font-size: 13px;
  }
  .line {
    color: #dcd6d6;
    margin: 0 8px;
  }
}

@media screen and (max-width: 720px) {
  .user-login {
    .content-wrapper {
      margin: 20px auto;
      top: 40px;
      max-width: 300px;
      display: block;
      .slogan {
        color: #666;
        font-size: 22px;
        line-height: 30px;
      }
    }
  }
}

</style>